import * as React from "react"

function FacebookSvg(props) {
    return (
        <svg width={26} height={26} viewBox="0 0 26 26" {...props}>
            <path
                d="M21.125 0H4.875A4.876 4.876 0 000 4.875v16.25A4.876 4.876 0 004.875 26h9.005V15.928h-3.385V12h3.385V9.105c0-3.352 2.065-5.18 5.061-5.18a27.012 27.012 0 013.013.152v3.5l-2.065.017c-1.642 0-1.947.762-1.947 1.9V12h3.876l-.508 3.927h-3.368V26h3.182A4.876 4.876 0 0026 21.125V4.875A4.876 4.876 0 0021.125 0z"
                fill="#fff"
                fillRule="evenodd"
            />
        </svg>
    )
}

export default FacebookSvg
